import { generateHex, Logger } from '@nu-art/ts-common';
import { ModuleFE_WorkHub } from '../_module/index.js';
import { Component_WorkHubActionMenu } from '../_ui/Component_WorkHubActionMenu/Component_WorkHubActionMenu.js';
export class WorkHubItem extends Logger {
    key;
    modulesToAwait;
    renderer;
    tabTag;
    tabTagLabel;
    customMenuActionsResolver;
    // ######################## Builder ########################
    constructor(key) {
        super(`WorkHubItem_${key}`);
        this.key = key;
        this.renderer = () => `Renderer not set for work hub item ${this.key}`;
        this.customMenuActionsResolver = () => [];
        ModuleFE_WorkHub.workHubItem.register(this);
    }
    setRenderer = (renderer) => {
        this.renderer = renderer;
        return this;
    };
    setTag = (tag, label) => {
        this.tabTag = tag;
        this.tabTagLabel = label;
        return this;
    };
    setModulesToAwait = (modules) => {
        this.modulesToAwait = modules;
        return this;
    };
    setCustomMenuActionsResolver = (resolver) => {
        this.customMenuActionsResolver = resolver;
        return this;
    };
    // ######################## Public Methods ########################
    openTab = (id, label, args) => {
        ModuleFE_WorkHub.tabs.add(this.prepareTab(id, label, args));
    };
    prepareTab = (id, label, args) => {
        return {
            itemKey: this.key,
            tag: this.tabTag,
            tagLabel: this.tabTagLabel,
            id,
            label,
            renderArgs: args,
        };
    };
    closeTab = (tabId) => {
        ModuleFE_WorkHub.tabs.remove(tabId);
    };
    openTabMenu = async (e, tab) => {
        const customSections = await this.customMenuActionsResolver(tab);
        Component_WorkHubActionMenu.show(e, {
            tabId: tab.id,
            customSections
        });
    };
    updateArgs = (tabId, args) => {
        ModuleFE_WorkHub.tabs.updateArgs(tabId, args);
    };
    openNewTabsInContext = (tabId, newTabs, customGroupName) => {
        const currentGroupKey = ModuleFE_WorkHub.group.getKeyForTabId(tabId);
        if (currentGroupKey)
            return ModuleFE_WorkHub.group.addTabs(currentGroupKey, newTabs);
        else
            ModuleFE_WorkHub.group.create(generateHex(4), tabId, newTabs, customGroupName ?? 'New Group');
    };
    updateTabLabel = (tabId, label) => {
        ModuleFE_WorkHub.tabs.updateLabel(tabId, label);
    };
}
//# sourceMappingURL=work-hub-item.js.map